"use client"

import { NotFoundPage } from "pages"

export default function NotFound() {
  return <NotFoundPage />
}
